import * as React from "react";

import styled from "react-emotion";
import Helmet from "react-helmet";
import SubHeadlineWithIcon from "./../components/HeadlineWithIcon";
import {Spacer} from "./../components/Spacer";
import {RouteComponentProps} from "react-router-dom";
import {Col, Grid, Row} from "react-flexbox-grid";
import StaticTextService from "../services/StaticTextService";
import {Button} from "../components/Button";

interface Props extends RouteComponentProps<{}> {
}

const Wrapper = styled(Grid)({
	marginTop: 50,
	marginBottom: 75,
	"@media (min-width: 576px)": {
		marginTop: 75,
		marginBottom: 100
	},
	"@media (min-width: 992px)": {
		marginTop: 100,
		marginBottom: 100
	},
	"& a": {
		color: "#000"
	},
	"& a:visited": {
		color: "#000"
	}
});

const ContactCard = styled("div")({
	color: "#fff",
	backgroundColor: "#000",
	padding: 20,
	display: "flex",
	flexDirection: "column",
	margin: "30px 0 50px",
	maxWidth: 400
});

const ContactInfos = styled("p")({
	marginBlockStart: "0",
	marginBlockEnd: "0",
	marginTop: "0.2em",
	marginBottom: "0.2em"
});

const ContactTitle = styled("p")({
	marginBlockStart: "0",
	marginBlockEnd: "0",
	marginTop: "0.3em",
	fontSize: "12px",
	marginBottom: "1.5em"
});



interface State {
}

class NewsLetterPage extends React.Component<Props, State> {


	public render() {
		return (
			<>
				<Helmet>
					<meta name="robots" content="noindex,nofollow"/>
					<title>{StaticTextService.getNewsletterPageTitle()}</title>
				</Helmet>
				<Wrapper>
					<Spacer>
						<SubHeadlineWithIcon>Newsletter Anmeldung</SubHeadlineWithIcon>
					</Spacer>
					<Row>
						<Col xs={12}>
							<h2>Keine Ankündigung mehr verpassen!</h2>
							<p>
								Jetzt für unseren Presse-Newsletter oder allgemeinen Konzert- und Tournee-Newsletter
								eintragen:
							</p>
						</Col>
					</Row>
					<Row>
						<Col xs={12} lg={6}>
							<h3>Sie sind Journalist*in?</h3>
							<p>Hier geht's zur Anmeldung für den Presse-Newsletter.</p>
							<details>
								<summary style={{ color: "white", padding:"10px 16px", backgroundColor:"black", fontWeight: "bold", fontSize: "18px", cursor: "pointer", width:"fit-content", listStyle:"none" }}>
									Presse-Newsletter abonnieren
								</summary>
								<iframe
									src="https://news.neuland-concerts.com/252/1147/522b6c5a6e/subscribe/form.html?_g=1765974275"
									frameborder="0" width="100%" height="1400"></iframe>
							</details>
						</Col>
						<Col xs={12} lg={6}>
							<h3>Du bist Konzertbesucher*in?</h3>
							<p>
								Du besuchst gerne Veranstaltungen und möchtest Informationen zu unseren Konzerten in
								Hamburg sowie zu unseren Tourneen erhalten? Trage dich hier für den Newsletter ein
								und erfahre, "where live is fantastic".
							</p>

							<details>
								<summary style={{ color: "white", padding:"10px 16px", backgroundColor:"black", fontWeight: "bold", fontSize: "18px", cursor: "pointer", width:"fit-content", listStyle:"none" }}>Newsletter abonnieren</summary>
								<iframe
									src="https://news.neuland-concerts.com/252/1893/88c6aef7be/subscribe/form.html?_g=1765974224"
									frameBorder="0" width="100%" height="800"></iframe>
							</details>


						</Col>
					</Row>
				</Wrapper>

			</>
		);
	}
}

export default NewsLetterPage;
